var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icono / Outlined / Solicitud No Resuelta") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.5,5.5 C13.5,6.328 12.828,7 12,7 C11.172,7 10.5,6.328 10.5,5.5 C10.5,4.672 11.172,4 12,4 C12.828,4 13.5,4.672 13.5,5.5 Z M19,21 L19,5 L14.52,5 L14.248,4.431 C13.826,3.548 12.965,3 12,3 C11.035,3 10.174,3.548 9.752,4.431 L9.48,5 L5,5 L5,21 L19,21 Z M19,3 C20.104,3 21,3.897 21,5 L21,21 C21,22.103 20.104,23 19,23 L5,23 C3.896,23 3,22.103 3,21 L3,5 C3,3.897 3.896,3 5,3 L8.271,3 C9.1,1.768 10.502,1 12,1 C13.498,1 14.9,1.768 15.729,3 L19,3 Z M15.5361,8.0498 C15.9271,7.6588 16.5581,7.6588 16.9491,8.0498 C17.3401,8.4408 17.3401,9.0728 16.9491,9.4638 L13.4141,12.9998 L16.9501,16.5358 C17.3411,16.9268 17.3411,17.5588 16.9501,17.9488 C16.5591,18.3398 15.9271,18.3398 15.5361,17.9488 L12.0001,14.4138 L8.4641,17.9498 C8.0731,18.3408 7.4411,18.3408 7.0511,17.9498 C6.6601,17.5598 6.6601,16.9268 7.0511,16.5358 L10.5861,12.9998 L7.0501,9.4638 C6.6591,9.0728 6.6591,8.4418 7.0501,8.0508 C7.4401,7.6598 8.0731,7.6598 8.4641,8.0508 L12.0001,11.5858 L15.5361,8.0498 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icono-/-Outlined-/-Solicitud-No-Resuelta",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Black-/-800",
    mask: "url(#mask-2)",
    fill: "#444444"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelBlack);
export default __webpack_public_path__ + "static/media/cancel-black.795afcfb7df8112974035f56b6adb6a4.svg";
export { ForwardRef as ReactComponent };